const basico3 = {
    titulo: `JavaScript: variables de tipo cadena de caracteres`,
    problemas: [
      {
        codigo: 1,
        descripcion: `En el concepto anterior vimos como trabajar con variables y valores numéricos, tanto con valores enteros y decimales. Ahora veremos como trabajar con variables de tipo cadena de caracteres o tambien llamadas strings.
Para definir e inicializar una variable de tipo cadena de caracteres utilizamos las comillas simples o dobles:
<pre>
let nombre = 'Juan'
</pre>
El resultado es exactamente el mismo si utilizamos comillas dobles:
<pre>
let nombre = "Juan"
</pre>
En el resutado del problema de abajo ingrese la cadena con comillas simples o dobles sino se mostrará como error (También es sencible a mayúsculas y minúsculas, no es lo mismo 'Estados Unidos' que 'estados unidos').
  `,
        programa: `let pais1 = 'México'
let pais2 = 'Estados Unidos'
let pais3 = 'Canadá'
console.log(pais2)`,
        solucion: "'Estados Unidos'"
      },{
        codigo: 2,
        descripcion: `Podemos directamente en el método log mostrar un mensaje encerrando la cadena de caracteres entre comillas simples o dobles.`,
        programa: `console.log('Sistema administrativo')`,
        solucion: "'Sistema administrativo'"
      },{
        codigo: 3,
        descripcion: `Un string puede tener cualquier tipo de caracteres: letras, números, espacios, signos de puntuación, emojis, etc.
No olvidar en el ejercicio de abajo encerrar entre comillas el emojis.`,
        programa: `let cara = '😊'
console.log(cara)`,
        solucion: "'😊'"
      },{
        codigo: 4,
        descripcion: `Un string puede tener más de un caracter, un caracter o inclusive una cadena vacía, es decir ningún caracter.`,
        programa: `let cadenaVacia = ''
console.log(cadenaVacia)`,
        solucion: "''"
      },{
        codigo: 5,
        descripcion: `Un string con un espacio en blanco no es un string vacío, es un string con un caracter (el espacio vacío).`,
        programa: `let espacio = ' '
console.log(espacio)`,
        solucion: "' '"
      },{
        codigo: 6,
        descripcion: `El único operador matemático que se puede utilizar en un string es el operador + (concatenación de strings).
El operador de concatenación (+) concatena dos valores de cadena, devolviendo otra cadena que es la unión de las dos cadenas.
<pre>
let cad1 = 'uno'
let cad2 = 'dos'
let todo = cad1 + cad2
console.log(todo)
</pre>
La variable todo almacena la cadena: 'unodos'. Si necesitamos que los textos dentro de la cadena estén separados por un espacio debemos modificar el algoritmo:
<pre>
let cad1 = 'uno '
let cad2 = 'dos'
let todo = cad1 + cad2
console.log(todo)
</pre>
Ahora el resultado es: 'uno dos'`,
        programa: `let nombre = "Juan"
let apellido = "Perez"
let nombreCompleto = nombre + " " + apellido
console.log(nombreCompleto)`,
        solucion: "'Juan Perez'"
      },{
        codigo: 7,
        descripcion: `Si tratamos de utilizar cualquiera de los otros operadores matemáticos que no sea el +, el resultado será un NaN (Not a Number)`,
        programa: `let nombre = "Juan"
let apellido = "Perez"
let producto = nombre * apellido
console.log(producto)`,
        solucion: "NaN"
      },{
        codigo: 8,
        descripcion: `Si concatenamos un string con un número, el resultado será un string.
<pre>
let edad = 30
let nombre = "Juan"
let datos = nombre + " tiene " + edad + " años"
console.log(datos)
</pre>
El resultado es: 'Juan tiene 30 años'`,
        programa: `let sueldo = 1000
let nombre = "Juan"
let resultado = nombre + " tiene " + sueldo + " pesos"
console.log(resultado)`,
        solucion: "'Juan tiene 1000 pesos'"
      },{
        codigo: 9,
        descripcion: `Lo único que hay que tener cuidado es si las dos primeras variables son numéricas, luego se suman numéricamente dichas variables y luego se concatenan con los strings.        
<pre>
let valor1 = 10
let valor2 = 20
let total = valor1 + valor2 + " fin"
console.log(total)
</pre>
El resultado es: '30 fin'`,
        programa: `let valor1 = 10
let valor2 = 20
let total = valor1 + (valor2 + " fin")
console.log(total)`,
        solucion: "'1020 fin'"
      },{
        codigo: 10,
        descripcion: `Existe en JavaScript otro tipo de string llamado template string, se las utiliza para sustituir variables dentro de un string y evitar la concatenación de strings.
<pre>
let nombre = "Juan"
let sueldo = 1000
let empleado = \`\${nombre} tiene un sueldo de \${sueldo}\`
console.log(empleado)        
</pre>
Utilizamos las comillas \` para indicar que es un template string. Luego para sustituir las variables dentro del string, utilizamos la  \${} y dentro de ésta se colocan las variables que queremos sustituir.
`,
        programa: `let nombre = "Juan"
let sueldo = 1000
let empleado = \`\${nombre} tiene un sueldo de \${sueldo}\`
console.log(empleado)`,
        solucion: "'Juan tiene un sueldo de 1000'"
      },{
        codigo: 11,
        descripcion: `Nos evita tener que utilizar el operador + para concatenar strings.`,
        programa: `let nombre = "Juan"
let sueldo = 1000
let empleado =nombre+ " tiene un sueldo de " + sueldo
console.log(empleado)`,
        solucion: "'Juan tiene un sueldo de 1000'"
      },{
        codigo: 12,
        descripcion: `Los template strings también se pueden utilizar para efectuar operaciones dentro de las llaves`,
        programa: `let valor1 = 10
let valor2 = 20
console.log(\`La suma de \${valor1} y \${valor2} es \${valor1 + valor2}\`)`,
        solucion: "'La suma de 10 y 20 es 30'"
      }
    ]
  }
  
  export default basico3;